module.exports = __webpack_public_path__ + "static/media/deleteIcon.7cfdc2fe.svg";